import React, { PropsWithChildren } from "react";
import { MatIconStyle as S } from "./MatIcon.style";
import { useClassNames } from "hooks/useClassNames";

export type MatIconProps = PropsWithChildren<
  React.ClassAttributes<HTMLElement> &
    React.HTMLAttributes<HTMLElement> & {
      size?: "small" | "large" | "extra-large" | "normal";
      className?: string;
      severity?: "primary" | "secondary" | "success" | "warning" | "danger" | "contrast";
    }
>;

export const MatIcon: React.FC<MatIconProps> = (props) => {
  const { children, size, className, ...cleanProps } = props;

  const classes = useClassNames(
    {
      "icon-normal": size === "normal",
      "icon-sm": size === "small",
      "icon-lg": size === "large",
      "icon-xl": size === "extra-large",
    },
    className,
    "material-symbols-sharp",
    `icon-${props.severity ?? "default"}`,
  );
  return (
    <S.MatIcon {...cleanProps} className={classes}>
      {children}
    </S.MatIcon>
  );
};
